import React from "react";
import { connect } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import styled from "styled-components";
import Paper from "@material-ui/core/Paper";
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import {
    gridStyle as gstyle,
    cellStyle as cstyle,
} from "../../reports/gridHelper";
import responseLevel from "./img/responsehint.png";
import responseLevel2 from "./img/responsehint2.png";
import {
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    Label,
    ModalHeader,
} from "reactstrap";

import { StyledCard, StyledContent, StyledHeader } from "../../styles";
import {
    Card,
    Button,
    Typography,
    withStyles,
    TextField,
    Table,
    TableBody,
    TableRow,
    MenuItem,
    Select,
} from "@material-ui/core";

import {
    getResponseMatrix,
    setResponseMatrixStatus,
    updateMatrix,
    setReportDetails,
    setSection2,
    setSection1,
    addGroup,
    getGroups,
    addItem,
    getItems,
    editGroup,
    removeGroup,
    editItem,
    removeItem,
    getTemplates,
    removeTemplate,
    archieveTemplate,
    getCopyTemplate,
    templateCopy,
} from "./actions";
import {
    selectResponseMatrix,
    selectGroup,
    selectItem,
    selectTemplate,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
    selectTemplateName,
    getSelectedTemplate,
} from "./selectors";

import IconButton from "@material-ui/core/IconButton";
const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;

const InfoPaper = styled(Paper)`
    height: 80%;
    overflow: scroll;
`;
const InfoModal = styled(Modal)`
    width: 90vw;
    height: 80vh;
    margin-top: 10vh;
    margin-right: 15vw;
    margin-left: 15vw;
    margin-bottom: 10vh;
`;

const InfoDiv = styled.div`
    display: flex;
    justify-content: end;
    padding: 30px;
`;

const styles = () => ({
    addUserModel: {
        width: "60%",
    },
    list: {
        width: "100%",
        marginTop: 15,
        marginBottom: 1,
        borderRadius: 5,
        backgroundColor: "#3f51b5",
    },
    listItem: {
        width: "auto",
        backgroundColor: "white",
        marginLeft: 10,
        marginRight: 10,
        borderRadius: 5,
        marginBottom: 1,
        marginTop: 1,
        padding: 0,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    form: {
        position: "relative",
        width: "90%",
    },
});
class Hsqe extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isResponseMatrix: false,
            isCreateTemplate: false,
            isTitleEntered: false,
            titleChangeModal: false,
            copyTitleName: "",
            prevTitleName: "",
            isSection1: false,
            isSection2: false,
            isSection3: false,
            isEditing: false,
            responseMatrix_status: false,
            newGroupModal: false,
            newItemModal: false,
            viewItemModal: false,
            editGroupModal: false,
            editItemModal: false,
            deleteTemplateModal: false,
            deleteGroupModal: false,
            section1Modal: false,
            section2Modal: false,
            section3Modal: false,
            responseInfoModal: false,
            warningModal: false,
            warningMessage: "",
            itemCount: 0,
            prevItemCount: 0,
            prevGroupCount: 0,
            groupCount: 0,
            editUID: "",
            itemAddGroupName: "",
            itemAddGroupId: "",
            groupIdReference: 0,
            itemIdReference: 0,
            response_matrix_1: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_2: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_3: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_4: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_5: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },

            section_1: {
                inspection_location: "Yes",
                project_title: "Yes",
                inspection_timestamp: "Yes",
                inspector_username: "Yes",
                inspection_reps: "No",
                project_id: "No",
                work_location: "Yes",
                works_description: "No",
                weather_conditions: "No",
                light_conditions: "No",
                visibility: "No",
                surface_conditions: "No",
                working_close_to_the_public: "No",
                client: "No",
                designer: "No",
                main_contractor: "No",
                sub_contractor: "No",
                psdp: "No",
                pscs: "No",
                external_circulation: "No",
            },
            section_2: {
                estimated_man_hours: "No",
                estimated_supervision_hours: "No",
                worker_health_summary: "No",
                incident_summary: "No",
                weeks_since_last_incident: "No",
                first_aid_incidents: "No",
                sswp_toolbox_talks_status: "No",
                ppe_status: "No",
                safety_enforcement: "No",
                visitor_records: "No",
                pending_hazardous_activities: "No",
                hsqe_summary: "No",
            },
            report_details: {
                report_title: "",
                pass_score: "",
                deleted: true,
            },
            new_group: {
                group_name: "",
                group_weight: "",
                group_id: "",
            },

            new_item: {
                item_name: "",
                item_weight: "",
                item_response_class: "",
                item_id: "",
            },
        };

        props.getResponseMatrix();
        props.getTemplates();
    }

    handleCloseModel = () => {
        this.setState({
            isTitleEntered: false,
            titleChangeModal: false,
            copyTitleName: "",
            prevTitleName: "",
            isResponseMatrix: false,
            isCreateTemplate: false,
            isSection1: false,
            isSection2: false,
            isSection3: false,
            isEditing: false,
            responseMatrix_status: false,
            newGroupModal: false,
            newItemModal: false,
            viewItemModal: false,
            editGroupModal: false,
            editItemModal: false,
            deleteTemplateModal: false,
            deleteGroupModal: false,
            warningModal: false,
            warningMessage: "",
            itemCount: 0,
            prevItemCount: 0,
            prevGroupCount: 0,
            groupCount: 0,
            editUID: "",
            // groupId: "",
            itemAddGroupName: "",
            itemAddGroupId: "",
            groupIdReference: 0,
            itemIdReference: 0,
            section1Modal: false,
            section2Modal: false,
            section3Modal: false,
            response_matrix_1: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_2: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_3: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_4: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            response_matrix_5: {
                green: "",
                a1: "",
                a2: "",
                a3: "",
                red: "",
            },
            section_1: {
                inspection_location: "Yes",
                project_title: "Yes",
                inspection_timestamp: "Yes",
                inspector_username: "Yes",
                inspection_reps: "No",
                project_id: "No",
                work_location: "Yes",
                works_description: "No",
                weather_conditions: "No",
                light_conditions: "No",
                visibility: "No",
                surface_conditions: "No",
                working_close_to_the_public: "No",
                client: "No",
                designer: "No",
                main_contractor: "No",
                sub_contractor: "No",
                psdp: "No",
                pscs: "No",
                external_circulation: "No",
            },
            section_2: {
                estimated_man_hours: "No",
                estimated_supervision_hours: "No",
                worker_health_summary: "No",
                incident_summary: "No",
                weeks_since_last_incident: "No",
                first_aid_incidents: "No",
                sswp_toolbox_talks_status: "No",
                ppe_status: "No",
                safety_enforcement: "No",
                visitor_records: "No",
                pending_hazardous_activities: "No",
                hsqe_summary: "No",
            },
            report_details: {
                report_title: "",
                pass_score: "",
                deleted: true,
            },
            new_group: {
                group_name: "",
                group_weight: "",
                group_id: "",
            },

            new_item: {
                item_name: "",
                item_weight: "",
                item_response_class: "",
                item_id: "",
            },
        });
    };
    handleNewGroupModal = () => {
        this.setState({
            newGroupModal: true,
            new_group: {
                group_name: "",
                group_weight: "",
                group_id: "",
            },
        });
    };
    handleItemCount = (type, prevState) => {
        let count = prevState;
        if (type === "add") {
            count = count + 1;
        } else {
            count = count - 1;
        }
        this.setState({
            itemIdReference: count,
        });
    };
    setItemId = (ref) => {
        let reference = ref;
        let newItem = this.state.new_item;
        newItem.item_id = reference;
        this.setState({
            new_item: newItem,
        });
    };
    setId = (ref) => {
        let reference = ref;
        let newGroup = this.state.new_group;
        newGroup.group_id = reference;
        this.setState({
            new_group: newGroup,
        });
    };

    handleCount = (type, prevState) => {
        let count = prevState;
        if (type === "add") {
            count = count + 1;
        } else {
            count = count - 1;
        }
        this.setState({
            groupIdReference: count,
        });
    };

    // dropdown create
    renderDropdownCreate = (number, color, matrix, ref) => {
        return (
            <Select
                style={{ width: "150px" }}
                value={ref}
                onChange={(event) => {
                    let responsematrix1 = matrix;
                    responsematrix1.color = event.target.value;
                    this.props.updateMatrix(
                        number,
                        color,
                        responsematrix1.color
                    );
                }}
            >
                <MenuItem value="N/A">N/A</MenuItem>
                <MenuItem value="Immediate">Immediate</MenuItem>
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
                <MenuItem value="4">4</MenuItem>
                <MenuItem value="5">5</MenuItem>
                <MenuItem value="6">6</MenuItem>
                <MenuItem value="7">7</MenuItem>
                <MenuItem value="8">8</MenuItem>
                <MenuItem value="9">9</MenuItem>
                <MenuItem value="10">10</MenuItem>
                <MenuItem value="11">11</MenuItem>
                <MenuItem value="12">12</MenuItem>
                <MenuItem value="13">13</MenuItem>
                <MenuItem value="14">14</MenuItem>
                <MenuItem value="15">15</MenuItem>
                <MenuItem value="16">16</MenuItem>
                <MenuItem value="17">17</MenuItem>
                <MenuItem value="18">18</MenuItem>
                <MenuItem value="19">19</MenuItem>
                <MenuItem value="20">20</MenuItem>
                <MenuItem value="21">21</MenuItem>
                <MenuItem value="22">22</MenuItem>
                <MenuItem value="23">23</MenuItem>
                <MenuItem value="24">24</MenuItem>
                <MenuItem value="25">25</MenuItem>
                <MenuItem value="26">26</MenuItem>
                <MenuItem value="27">27</MenuItem>
                <MenuItem value="28">28</MenuItem>
                <MenuItem value="29">29</MenuItem>
                <MenuItem value="30">30</MenuItem>
                <MenuItem value="31">31</MenuItem>
            </Select>
        );
    };
    // dropdown
    renderDropdown = (number, color, edit, matrix, ref) => {
        return (
            <Select
                style={{ width: "150px" }}
                value={ref}
                disabled={edit ? false : true}
                onChange={(event) => {
                    let responsematrix1 = matrix;
                    responsematrix1.color = event.target.value;
                    this.props.updateMatrix(
                        number,
                        color,
                        responsematrix1.color
                    );
                }}
            >
                <MenuItem value="N/A">N/A</MenuItem>
                <MenuItem value="Immediate">Immediate</MenuItem>
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
                <MenuItem value="4">4</MenuItem>
                <MenuItem value="5">5</MenuItem>
                <MenuItem value="6">6</MenuItem>
                <MenuItem value="7">7</MenuItem>
                <MenuItem value="8">8</MenuItem>
                <MenuItem value="9">9</MenuItem>
                <MenuItem value="10">10</MenuItem>
                <MenuItem value="11">11</MenuItem>
                <MenuItem value="12">12</MenuItem>
                <MenuItem value="13">13</MenuItem>
                <MenuItem value="14">14</MenuItem>
                <MenuItem value="15">15</MenuItem>
                <MenuItem value="16">16</MenuItem>
                <MenuItem value="17">17</MenuItem>
                <MenuItem value="18">18</MenuItem>
                <MenuItem value="19">19</MenuItem>
                <MenuItem value="20">20</MenuItem>
                <MenuItem value="21">21</MenuItem>
                <MenuItem value="22">22</MenuItem>
                <MenuItem value="23">23</MenuItem>
                <MenuItem value="24">24</MenuItem>
                <MenuItem value="25">25</MenuItem>
                <MenuItem value="26">26</MenuItem>
                <MenuItem value="27">27</MenuItem>
                <MenuItem value="28">28</MenuItem>
                <MenuItem value="29">29</MenuItem>
                <MenuItem value="30">30</MenuItem>
                <MenuItem value="31">31</MenuItem>
            </Select>
        );
    };

    render() {
        const groups = this.props.groups === [] ? false : this.props.groups;

        // const items =
        //     this.props.items === [] ? false : this.props.items;

        const templates =
            this.props.templates === [] ? false : this.props.templates;
        const { templateTitles, copyTemp } = this.props;
        let color = this.props.color;
        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5">
                        Custom Inspection Template
                    </Typography>
                </StyledHeader>
                <StyledContent>
                    <div>
                        {this.props.canUpdate && (
                            <Button
                                style={{
                                    width: "500px",
                                    marginLeft: "30px",
                                    backgroundColor: "#0188cc",
                                }}
                                onClick={() => {
                                    this.setState({
                                        isResponseMatrix: true,
                                        isCreateTemplate: false,
                                    });
                                }}
                            >
                                <b style={{ color: "white" }}>
                                    {" "}
                                    Response Level{" "}
                                </b>
                            </Button>
                        )}
                        {this.props.canCreate && (
                            <Button
                                style={{
                                    width: "500px",
                                    // marginTop: "30px",
                                    marginLeft: "30px",
                                    backgroundColor: "#0188cc",
                                }}
                                onClick={() => {
                                    this.setState({
                                        isCreateTemplate: true,
                                        isResponseMatrix: false,
                                        isSection1: true,
                                    });
                                }}
                            >
                                <b style={{ color: "white" }}>
                                    {" "}
                                    Create HSQE Template{" "}
                                </b>
                            </Button>
                        )}
                    </div>
                    {this.state.isResponseMatrix === true &&
                    this.props.matrix.response_matrix_status === false ? (
                        <>
                            <br />
                            <br />
                            <div style={gstyle(4, 9, null, color)}>
                                <div style={cstyle(15, 1, 15, 3, false, false)}>
                                    <span>
                                        <b>Response Level</b>
                                    </span>
                                    <span>
                                        <IconButton
                                            style={{
                                                color: "#0188cc",
                                                marginTop: "-13px",
                                                float: "right",
                                            }}
                                            onClick={() => {
                                                this.setState({
                                                    responseInfoModal: true,
                                                });
                                            }}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    </span>
                                </div>
                                <div style={cstyle(15, 3, 15, 6, false, false)}>
                                    <b>Green</b>
                                </div>
                                <div style={cstyle(15, 6, 15, 9, false, false)}>
                                    <b> Amber1</b>
                                </div>
                                <div
                                    style={cstyle(15, 9, 15, 13, false, false)}
                                >
                                    <b> Amber 2</b>
                                </div>
                                <div
                                    style={cstyle(15, 13, 15, 17, false, false)}
                                >
                                    <b> Amber 3</b>
                                </div>
                                <div
                                    style={cstyle(15, 17, 15, 22, false, false)}
                                >
                                    <b> Red </b>
                                </div>
                                <div style={cstyle(16, 1, 16, 3)}>
                                    <b>1</b>
                                </div>
                                <div style={cstyle(16, 3, 16, 6, true)}>
                                    {this.renderDropdownCreate(
                                        1,
                                        "green",
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].green
                                    )}
                                </div>
                                <div style={cstyle(16, 6, 16, 9, true)}>
                                    {this.renderDropdownCreate(
                                        1,
                                        "a1",
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].a1
                                    )}
                                </div>
                                <div style={cstyle(16, 9, 16, 13, true)}>
                                    {this.renderDropdownCreate(
                                        1,
                                        "a2",
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].a2
                                    )}
                                </div>
                                <div style={cstyle(16, 13, 16, 17, true)}>
                                    {this.renderDropdownCreate(
                                        1,
                                        "a3",
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].a3
                                    )}
                                </div>
                                <div style={cstyle(16, 17, 16, 22, true)}>
                                    {this.renderDropdownCreate(
                                        1,
                                        "red",
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].red
                                    )}
                                </div>
                                <div style={cstyle(17, 1, 17, 3)}>
                                    <b>2</b>
                                </div>
                                <div style={cstyle(17, 3, 17, 6, true)}>
                                    {this.renderDropdownCreate(
                                        2,
                                        "green",
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].green
                                    )}
                                </div>
                                <div style={cstyle(17, 6, 17, 9, true)}>
                                    {this.renderDropdownCreate(
                                        2,
                                        "a1",
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].a1
                                    )}
                                </div>
                                <div style={cstyle(17, 9, 17, 13, true)}>
                                    {this.renderDropdownCreate(
                                        2,
                                        "a2",
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].a2
                                    )}
                                </div>
                                <div style={cstyle(17, 13, 17, 17, true)}>
                                    {this.renderDropdownCreate(
                                        2,
                                        "a3",
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].a3
                                    )}
                                </div>
                                <div style={cstyle(17, 17, 17, 22, true)}>
                                    {this.renderDropdownCreate(
                                        2,
                                        "red",
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].red
                                    )}
                                </div>
                                <div style={cstyle(18, 1, 18, 3)}>
                                    <b>3</b>
                                </div>
                                <div style={cstyle(18, 3, 18, 6, true)}>
                                    {this.renderDropdownCreate(
                                        3,
                                        "green",
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].green
                                    )}
                                </div>
                                <div style={cstyle(18, 6, 18, 9, true)}>
                                    {this.renderDropdownCreate(
                                        3,
                                        "a1",
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].a1
                                    )}
                                </div>
                                <div style={cstyle(18, 9, 18, 13, true)}>
                                    {this.renderDropdownCreate(
                                        3,
                                        "a2",
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].a2
                                    )}
                                </div>
                                <div style={cstyle(18, 13, 18, 17, true)}>
                                    {this.renderDropdownCreate(
                                        3,
                                        "a3",
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].a3
                                    )}
                                </div>
                                <div style={cstyle(18, 17, 18, 22, true)}>
                                    {this.renderDropdownCreate(
                                        3,
                                        "red",
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].red
                                    )}
                                </div>
                                <div style={cstyle(19, 1, 19, 3)}>
                                    <b>4</b>
                                </div>
                                <div style={cstyle(19, 3, 19, 6, true)}>
                                    {this.renderDropdownCreate(
                                        4,
                                        "green",
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].green
                                    )}
                                </div>
                                <div style={cstyle(19, 6, 19, 9, true)}>
                                    {this.renderDropdownCreate(
                                        4,
                                        "a1",
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].a1
                                    )}
                                </div>
                                <div style={cstyle(19, 9, 19, 13, true)}>
                                    {this.renderDropdownCreate(
                                        4,
                                        "a2",
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].a2
                                    )}
                                </div>
                                <div style={cstyle(19, 13, 19, 17, true)}>
                                    {this.renderDropdownCreate(
                                        4,
                                        "a3",
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].a3
                                    )}
                                </div>
                                <div style={cstyle(19, 17, 19, 22, true)}>
                                    {this.renderDropdownCreate(
                                        4,
                                        "red",
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].red
                                    )}
                                </div>
                                <div style={cstyle(20, 1, 20, 3)}>
                                    <b>5</b>
                                </div>
                                <div style={cstyle(20, 3, 20, 6, true)}>
                                    {this.renderDropdownCreate(
                                        5,
                                        "green",
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].green
                                    )}
                                </div>
                                <div style={cstyle(20, 6, 20, 9, true)}>
                                    {this.renderDropdownCreate(
                                        5,
                                        "a1",
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].a1
                                    )}
                                </div>
                                <div style={cstyle(20, 9, 20, 13, true)}>
                                    {this.renderDropdownCreate(
                                        5,
                                        "a2",
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].a2
                                    )}
                                </div>
                                <div style={cstyle(20, 13, 20, 17, true)}>
                                    {this.renderDropdownCreate(
                                        5,
                                        "a3",
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].a3
                                    )}
                                </div>
                                <div style={cstyle(20, 17, 20, 22, true)}>
                                    {this.renderDropdownCreate(
                                        5,
                                        "red",
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].red
                                    )}
                                </div>
                            </div>
                            <br />
                            <br />
                            <Button
                                style={{
                                    width: "150px",
                                    float: "right",
                                    backgroundColor: "#0188cc",
                                }}
                                onClick={() => {
                                    this.props.setResponseMatrixStatus(true);
                                    this.setState({
                                        isResponseMatrix: false,
                                        responseMatrix_status: true,
                                    });
                                }}
                            >
                                <b style={{ color: "white" }}> Submit </b>
                            </Button>
                        </>
                    ) : (
                        ""
                    )}
                    {this.state.isResponseMatrix === true &&
                    this.props.matrix.response_matrix_status === true ? (
                        <>
                            <br />
                            <br />
                            <div style={gstyle(4, 9, null, color)}>
                                <div style={cstyle(15, 1, 15, 3, false, false)}>
                                    <span>
                                        <b>Response Level</b>
                                    </span>
                                    <span>
                                        <IconButton
                                            style={{
                                                color: "#0188cc",
                                                marginTop: "-13px",
                                                float: "right",
                                            }}
                                            onClick={() => {
                                                this.setState({
                                                    responseInfoModal: true,
                                                });
                                            }}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    </span>
                                </div>
                                <div style={cstyle(15, 3, 15, 6, false, false)}>
                                    <b>Green</b>
                                </div>
                                <div style={cstyle(15, 6, 15, 9, false, false)}>
                                    <b> Amber1</b>
                                </div>
                                <div
                                    style={cstyle(15, 9, 15, 13, false, false)}
                                >
                                    <b> Amber 2</b>
                                </div>
                                <div
                                    style={cstyle(15, 13, 15, 17, false, false)}
                                >
                                    <b> Amber 3</b>
                                </div>
                                <div
                                    style={cstyle(15, 17, 15, 22, false, false)}
                                >
                                    <b> Red </b>
                                </div>
                                <div style={cstyle(16, 1, 16, 3)}>
                                    <b>1</b>
                                </div>
                                <div style={cstyle(16, 3, 16, 6, true)}>
                                    {this.renderDropdown(
                                        1,
                                        "green",
                                        this.state.isEditing,
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].green
                                    )}
                                </div>
                                <div style={cstyle(16, 6, 16, 9, true)}>
                                    {this.renderDropdown(
                                        1,
                                        "a1",
                                        this.state.isEditing,
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].a1
                                    )}
                                </div>
                                <div style={cstyle(16, 9, 16, 13, true)}>
                                    {this.renderDropdown(
                                        1,
                                        "a2",
                                        this.state.isEditing,
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].a2
                                    )}
                                </div>
                                <div style={cstyle(16, 13, 16, 17, true)}>
                                    {this.renderDropdown(
                                        1,
                                        "a3",
                                        this.state.isEditing,
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].a3
                                    )}
                                </div>
                                <div style={cstyle(16, 17, 16, 22, true)}>
                                    {this.renderDropdown(
                                        1,
                                        "red",
                                        this.state.isEditing,
                                        this.state.response_matrix_1,
                                        this.props.matrix[1].red
                                    )}
                                </div>
                                <div style={cstyle(17, 1, 17, 3)}>
                                    <b>2</b>
                                </div>
                                <div style={cstyle(17, 3, 17, 6, true)}>
                                    {this.renderDropdown(
                                        2,
                                        "green",
                                        this.state.isEditing,
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].green
                                    )}
                                </div>
                                <div style={cstyle(17, 6, 17, 9, true)}>
                                    {this.renderDropdown(
                                        2,
                                        "a1",
                                        this.state.isEditing,
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].a1
                                    )}
                                </div>
                                <div style={cstyle(17, 9, 17, 13, true)}>
                                    {this.renderDropdown(
                                        2,
                                        "a2",
                                        this.state.isEditing,
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].a2
                                    )}
                                </div>
                                <div style={cstyle(17, 13, 17, 17, true)}>
                                    {this.renderDropdown(
                                        2,
                                        "a3",
                                        this.state.isEditing,
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].a3
                                    )}
                                </div>
                                <div style={cstyle(17, 17, 17, 22, true)}>
                                    {this.renderDropdown(
                                        2,
                                        "red",
                                        this.state.isEditing,
                                        this.state.response_matrix_2,
                                        this.props.matrix[2].red
                                    )}
                                </div>
                                <div style={cstyle(18, 1, 18, 3)}>
                                    <b>3</b>
                                </div>
                                <div style={cstyle(18, 3, 18, 6, true)}>
                                    {this.renderDropdown(
                                        3,
                                        "green",
                                        this.state.isEditing,
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].green
                                    )}
                                </div>
                                <div style={cstyle(18, 6, 18, 9, true)}>
                                    {this.renderDropdown(
                                        3,
                                        "a1",
                                        this.state.isEditing,
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].a1
                                    )}
                                </div>
                                <div style={cstyle(18, 9, 18, 13, true)}>
                                    {this.renderDropdown(
                                        3,
                                        "a2",
                                        this.state.isEditing,
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].a2
                                    )}
                                </div>
                                <div style={cstyle(18, 13, 18, 17, true)}>
                                    {this.renderDropdown(
                                        3,
                                        "a3",
                                        this.state.isEditing,
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].a3
                                    )}
                                </div>
                                <div style={cstyle(18, 17, 18, 22, true)}>
                                    {this.renderDropdown(
                                        3,
                                        "red",
                                        this.state.isEditing,
                                        this.state.response_matrix_3,
                                        this.props.matrix[3].red
                                    )}
                                </div>
                                <div style={cstyle(19, 1, 19, 3)}>
                                    <b>4</b>
                                </div>
                                <div style={cstyle(19, 3, 19, 6, true)}>
                                    {this.renderDropdown(
                                        4,
                                        "green",
                                        this.state.isEditing,
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].green
                                    )}
                                </div>
                                <div style={cstyle(19, 6, 19, 9, true)}>
                                    {this.renderDropdown(
                                        4,
                                        "a1",
                                        this.state.isEditing,
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].a1
                                    )}
                                </div>
                                <div style={cstyle(19, 9, 19, 13, true)}>
                                    {this.renderDropdown(
                                        4,
                                        "a2",
                                        this.state.isEditing,
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].a2
                                    )}
                                </div>
                                <div style={cstyle(19, 13, 19, 17, true)}>
                                    {this.renderDropdown(
                                        4,
                                        "a3",
                                        this.state.isEditing,
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].a3
                                    )}
                                </div>
                                <div style={cstyle(19, 17, 19, 22, true)}>
                                    {this.renderDropdown(
                                        4,
                                        "red",
                                        this.state.isEditing,
                                        this.state.response_matrix_4,
                                        this.props.matrix[4].red
                                    )}
                                </div>
                                <div style={cstyle(20, 1, 20, 3)}>
                                    <b>5</b>
                                </div>
                                <div style={cstyle(20, 3, 20, 6, true)}>
                                    {this.renderDropdown(
                                        5,
                                        "green",
                                        this.state.isEditing,
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].green
                                    )}
                                </div>
                                <div style={cstyle(20, 6, 20, 9, true)}>
                                    {this.renderDropdown(
                                        5,
                                        "a1",
                                        this.state.isEditing,
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].a1
                                    )}
                                </div>
                                <div style={cstyle(20, 9, 20, 13, true)}>
                                    {this.renderDropdown(
                                        5,
                                        "a2",
                                        this.state.isEditing,
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].a2
                                    )}
                                </div>
                                <div style={cstyle(20, 13, 20, 17, true)}>
                                    {this.renderDropdown(
                                        5,
                                        "a3",
                                        this.state.isEditing,
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].a3
                                    )}
                                </div>
                                <div style={cstyle(20, 17, 20, 22, true)}>
                                    {this.renderDropdown(
                                        5,
                                        "red",
                                        this.state.isEditing,
                                        this.state.response_matrix_5,
                                        this.props.matrix[5].red
                                    )}
                                </div>
                            </div>
                            <br />
                            <br />
                            {this.state.isEditing === false ? (
                                <>
                                    <Button
                                        style={{
                                            width: "100px",
                                            float: "right",
                                            backgroundColor: "#0188cc",
                                            marginLeft: "10px",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                isEditing: true,
                                            });
                                        }}
                                    >
                                        <b style={{ color: "white" }}> Edit </b>
                                    </Button>
                                    <Button
                                        style={{
                                            width: "100px",
                                            float: "right",
                                            backgroundColor: "#f95959",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                isResponseMatrix: false,
                                                isEditing: false,
                                            });
                                        }}
                                    >
                                        <b style={{ color: "white" }}>
                                            {" "}
                                            Close{" "}
                                        </b>
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        style={{
                                            width: "100px",
                                            float: "right",
                                            backgroundColor: "#0188cc",
                                            marginLeft: "10px",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                isEditing: false,
                                            });
                                        }}
                                    >
                                        <b style={{ color: "white" }}>
                                            {" "}
                                            Submit{" "}
                                        </b>
                                    </Button>
                                    <Button
                                        style={{
                                            width: "100px",
                                            float: "right",
                                            backgroundColor: "#f95959",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                isEditing: false,
                                            });
                                        }}
                                    >
                                        <b style={{ color: "white" }}>
                                            {" "}
                                            Cancel{" "}
                                        </b>
                                    </Button>
                                </>
                            )}
                        </>
                    ) : (
                        ""
                    )}

                    {this.state.isResponseMatrix === false &&
                    this.state.isCreateTemplate === false ? (
                        <>
                        <br/>
                        <br/>
                            {templates && templates.length !== 0 ? (
                                <div>
                                    <Card>
                                        <StyledHeader
                                            style={{
                                                padding: "0px",
                                                backgroundColor: "#0188CC",
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                style={{
                                                    textAlign: "center",
                                                    color: "white",
                                                }}
                                            >
                                                Inspection Templates
                                            </Typography>
                                        </StyledHeader>
                                    </Card>
                                </div>
                            ) : (
                                ""
                            )}
                            <div>
                            <Table>
                                <TableBody>
                                    {templates &&
                                        templates.map((e, i) => {
                                            return e.profile.deleted ===
                                                true ? (
                                                ""
                                            ) : (
                                                <TableRow key={i}>
                                                    <div
                                                        className="icon-text-container"
                                                        style={{
                                                            borderWidth:
                                                                "medium",
                                                            border:
                                                                "2px solid #0188cc",
                                                            borderRadius: "9px",
                                                            marginTop: "22px",
                                                            marginLeft: "10px",
                                                            marginRight: "10px",
                                                            marginBottom:
                                                                "10px",
                                                        }}
                                                    >
                                                        <div
                                                            className="float-left text-container"
                                                            style={{
                                                                display: "flex",
                                                            }}
                                                        >
                                                            <span>
                                                                <h5
                                                                    style={{
                                                                        border:
                                                                            "2px solid #0188cc",
                                                                        marginLeft:
                                                                            "10px",
                                                                        borderRadius:
                                                                            "12px",
                                                                        padding:
                                                                            "7px",
                                                                        textAlign:
                                                                            "center",
                                                                        width:
                                                                            "580px",
                                                                        marginTop:
                                                                            "14px",
                                                                    }}
                                                                >
                                                                    <b>
                                                                        Template
                                                                        Name:
                                                                    </b>{" "}
                                                                    <span className="subHeading">
                                                                        {
                                                                            e
                                                                                .profile
                                                                                .report_title
                                                                        }
                                                                    </span>
                                                                </h5>
                                                            </span>
                                                            <span>
                                                                <h5
                                                                    style={{
                                                                        border:
                                                                            "2px solid #0188cc",
                                                                        marginLeft:
                                                                            "15px",
                                                                        borderRadius:
                                                                            "12px",
                                                                        padding:
                                                                            "7px",
                                                                        textAlign:
                                                                            "center",
                                                                        width:
                                                                            "380px",
                                                                        marginTop:
                                                                            "14px",
                                                                    }}
                                                                >
                                                                    <b>
                                                                        Pass
                                                                        Percentage:
                                                                    </b>{" "}
                                                                    <span className="subHeading">
                                                                        {
                                                                            e
                                                                                .profile
                                                                                .pass_score
                                                                        }
                                                                    </span>
                                                                </h5>
                                                            </span>
                                                        </div>
                                                       
                                                        <div style={{
                                                                display: "inline-block",
                                                            }}>
                                                            <Button
                                                                style={{
                                                                    backgroundColor:
                                                                        "#0188CC",
                                                                    color:
                                                                        "white",
                                                                    marginLeft:
                                                                        "50px",
                                                                    marginBottom:
                                                                        "10px",
                                                                    width:
                                                                        "300px",
                                                                }}
                                                                variant="contained"
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            section_1:
                                                                                e
                                                                                    .details
                                                                                    .section_1,
                                                                            section1Modal: true,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                Inspection
                                                                Details
                                                            </Button>

                                                            <Button
                                                                style={{
                                                                    backgroundColor:
                                                                        "#0188CC",
                                                                    color:
                                                                        "white",
                                                                    marginLeft:
                                                                        "10px",
                                                                    marginBottom:
                                                                        "10px",
                                                                    width:
                                                                        "300px",
                                                                }}
                                                                variant="contained"
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            section_2:
                                                                                e
                                                                                    .details
                                                                                    .section_2,
                                                                            section2Modal: true,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                Work Details
                                                            </Button>

                                                            <Button
                                                                style={{
                                                                    backgroundColor:
                                                                        "#0188CC",
                                                                    color:
                                                                        "white",
                                                                    marginLeft:
                                                                        "10px",
                                                                    marginBottom:
                                                                        "10px",
                                                                    width:
                                                                        "300px",
                                                                }}
                                                                variant="contained"
                                                                onClick={() => {
                                                                    this.props.getGroups(
                                                                        e
                                                                            .profile
                                                                            .report_title
                                                                    );
                                                                    this.setState(
                                                                        {
                                                                            section3Modal: true,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                Inspection Items
                                                            </Button>
                                                            {this.props
                                                                .canDelete ===
                                                            true ? (
                                                                <IconButton
                                                                    style={{
                                                                        color:
                                                                            "red",
                                                                        paddingBottom:
                                                                            "10px",
                                                                        float:
                                                                            "right",
                                                                    }}
                                                                    onClick={() => {
                                                                        this.props.getCopyTemplate(
                                                                            e
                                                                                .profile
                                                                                .report_title
                                                                        );
                                                                        this.setState(
                                                                            {
                                                                                report_details:
                                                                                    e.profile,
                                                                                deleteTemplateModal: true,
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                        <div className="clear"></div>
                                                    </div>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </div>
                        </>
                    ) : (
                        ""
                    )}
                    {this.state.isCreateTemplate === true &&
                    this.props.matrix.response_matrix_status === false ? (
                        <>
                            <br />
                            <br />
                            <p style={{ color: "red" }}>
                                Please Submit the response level before creating
                                the template
                            </p>
                        </>
                    ) : this.state.isCreateTemplate === true &&
                      this.state.isSection1 === true &&
                      this.props.matrix.response_matrix_status === true ? (
                        <>
                            <br />
                            <br />
                            <Card>
                                <StyledHeader>
                                    <Typography variant="headline">
                                        Section 1 - Inspection Details
                                    </Typography>
                                </StyledHeader>
                                <StyledContent>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                width: "60%",
                                                float: "left",
                                            }}
                                        >
                                            <div
                                                style={gstyle(
                                                    5,
                                                    13,
                                                    null,
                                                    color
                                                )}
                                            >
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        13,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>Details</b>
                                                </div>
                                                <div
                                                    style={cstyle(2, 1, 2, 13)}
                                                >
                                                    <b>Title:</b>
                                                </div>
                                                <div
                                                    style={cstyle(2, 7, 2, 13)}
                                                >
                                                    {this.state
                                                        .isTitleEntered ===
                                                    false ? (
                                                        <TextField
                                                            id="title"
                                                            multiline={false}
                                                            style={{
                                                                width: "250px",
                                                            }}
                                                            value={
                                                                this.state
                                                                    .report_details
                                                                    .report_title
                                                            }
                                                            onChange={(
                                                                event
                                                            ) => {
                                                                let ref =
                                                                    event.target
                                                                        .value;
                                                                let reportTitle = this
                                                                    .state
                                                                    .report_details;
                                                                reportTitle.report_title =
                                                                    event.target.value;
                                                                this.setState({
                                                                    report_details: reportTitle,
                                                                });
                                                                if (
                                                                    !ref.replace(
                                                                        /\s/g,
                                                                        ""
                                                                    ).length
                                                                ) {
                                                                    this.setState(
                                                                        {
                                                                            warningModal: true,
                                                                            warningMessage:
                                                                                "Template name should not start from whitespace (ie. spaces, tabs or line breaks)!!",
                                                                            report_details: {
                                                                                report_title:
                                                                                    "",
                                                                                pass_score:
                                                                                    "",
                                                                                deleted: true,
                                                                            },
                                                                        }
                                                                    );
                                                                }
                                                                if (
                                                                    templateTitles.includes(
                                                                        event
                                                                            .target
                                                                            .value
                                                                    ) === true
                                                                ) {
                                                                    this.setState(
                                                                        {
                                                                            warningModal: true,
                                                                            warningMessage:
                                                                                "Template name already exists!!",
                                                                            report_details: {
                                                                                report_title:
                                                                                    "",
                                                                                pass_score:
                                                                                    "",
                                                                                deleted: true,
                                                                            },
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    ) : (
                                                        <>
                                                            <span>
                                                                <TextField
                                                                    id="title"
                                                                    multiline={
                                                                        false
                                                                    }
                                                                    style={{
                                                                        width:
                                                                            "250px",
                                                                        pointerEvents:
                                                                            "none",
                                                                    }}
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .report_details
                                                                            .report_title
                                                                    }
                                                                    onChange={(
                                                                        event
                                                                    ) => {
                                                                        let reportTitle = this
                                                                            .state
                                                                            .report_details;
                                                                        reportTitle.report_title =
                                                                            event.target.value;
                                                                        this.setState(
                                                                            {
                                                                                report_details: reportTitle,
                                                                            }
                                                                        );
                                                                        let ref =
                                                                            event
                                                                                .target
                                                                                .value;
                                                                        if (
                                                                            !ref.replace(
                                                                                /\s/g,
                                                                                ""
                                                                            )
                                                                                .length
                                                                        ) {
                                                                            this.setState(
                                                                                {
                                                                                    warningModal: true,
                                                                                    warningMessage:
                                                                                        "Template name should not start from whitespace (ie. spaces, tabs or line breaks)!!",
                                                                                    report_details: {
                                                                                        report_title:
                                                                                            "",
                                                                                        pass_score:
                                                                                            "",
                                                                                        deleted: true,
                                                                                    },
                                                                                }
                                                                            );
                                                                        }

                                                                        if (
                                                                            templateTitles.includes(
                                                                                event
                                                                                    .target
                                                                                    .value
                                                                            ) ===
                                                                            true
                                                                        ) {
                                                                            this.setState(
                                                                                {
                                                                                    warningModal: true,
                                                                                    warningMessage:
                                                                                        "Template name already exists!!",
                                                                                    report_details: {
                                                                                        report_title:
                                                                                            "",
                                                                                        pass_score:
                                                                                            "",
                                                                                        deleted: true,
                                                                                    },
                                                                                }
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            </span>
                                                            <span>
                                                                <IconButton
                                                                    style={{
                                                                        color:
                                                                            "#0188cc",
                                                                        border:
                                                                            "1px solid #0188cc",
                                                                        marginLeft:
                                                                            "70px",
                                                                        float:
                                                                            "right",
                                                                        marginTop:
                                                                            "0px",
                                                                    }}
                                                                    onClick={() => {
                                                                        this.props.getCopyTemplate(
                                                                            this
                                                                                .state
                                                                                .report_details
                                                                                .report_title
                                                                        );
                                                                        this.setState(
                                                                            {
                                                                                titleChangeModal: true,
                                                                                prevTitleName: this
                                                                                    .state
                                                                                    .report_details
                                                                                    .report_title,
                                                                            }
                                                                        );
                                                                        // let countReference = parseInt(e.profile.group_weight, 10)
                                                                        // this.setState({

                                                                        //     editUID:
                                                                        //         e.profile.group_id,
                                                                        //     new_group: e.profile,
                                                                        //     editGroupModal: true,
                                                                        //     prevGroupCount: this.state.groupCount,
                                                                        //     groupCount: this.state.groupCount - countReference
                                                                        // });
                                                                    }}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </span>
                                                        </>
                                                    )}
                                                </div>
                                                <div
                                                    style={cstyle(3, 1, 3, 13)}
                                                >
                                                    <b>Pass Pecentage:</b>
                                                </div>
                                                <div
                                                    style={cstyle(3, 7, 3, 13)}
                                                >
                                                    <TextField
                                                        id="title"
                                                        helperText="Pass Pecentage should always be whole number"
                                                        type="number"
                                                        multiline={false}
                                                        style={{
                                                            width: "250px",
                                                        }}
                                                        value={
                                                            this.state
                                                                .report_details
                                                                .pass_score
                                                        }
                                                        onChange={(event) => {
                                                            let reportTitle = this
                                                                .state
                                                                .report_details;
                                                            reportTitle.pass_score =
                                                                event.target.value;
                                                            this.setState({
                                                                report_details: reportTitle,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <div
                                        style={{ width: "100%", clear: "both" }}
                                    >
                                        <div style={gstyle(5, 4, null, color)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "229px",
                                                    }}
                                                >
                                                    Inspection
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    2,
                                                    1,
                                                    3,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "150px",
                                                    }}
                                                >
                                                    Status
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    1,
                                                    2,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Inspection Location
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    2,
                                                    2,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .inspection_location
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.inspection_location =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    1,
                                                    3,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Inspection Timestamp
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    2,
                                                    3,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .inspection_timestamp
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.inspection_timestamp =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    1,
                                                    4,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Inspection Reps
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    2,
                                                    4,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .inspection_reps
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.inspection_reps =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    1,
                                                    5,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Project ID
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    2,
                                                    5,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .project_id
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.project_id =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>

                                            <div
                                                style={cstyle(
                                                    6,
                                                    1,
                                                    6,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Project Title
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    6,
                                                    2,
                                                    6,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .project_title
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.project_title =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    {/* <MenuItem value="No">
                                                            No
                                                        </MenuItem> */}
                                                </Select>
                                            </div>

                                            <div
                                                style={cstyle(
                                                    7,
                                                    1,
                                                    7,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Work Location
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    7,
                                                    2,
                                                    7,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .work_location
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.work_location =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    {/* <MenuItem value="No">
                                                            No
                                                        </MenuItem> */}
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    1,
                                                    8,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Works Description
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    2,
                                                    8,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .works_description
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.works_description =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>

                                            <div
                                                style={cstyle(
                                                    9,
                                                    1,
                                                    9,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Weather Conditions
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    9,
                                                    2,
                                                    9,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .weather_conditions
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.weather_conditions =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    1,
                                                    10,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Light Conditions
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    2,
                                                    10,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .light_conditions
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.light_conditions =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>

                                            <div
                                                style={cstyle(
                                                    11,
                                                    1,
                                                    11,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Visibility{" "}
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    2,
                                                    11,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .visibility
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.visibility =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    1,
                                                    12,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Surface Conditions
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    2,
                                                    12,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .surface_conditions
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.surface_conditions =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    13,
                                                    1,
                                                    13,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Working Close to the public
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    13,
                                                    2,
                                                    13,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .working_close_to_the_public
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.working_close_to_the_public =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    14,
                                                    1,
                                                    14,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Client
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    14,
                                                    2,
                                                    14,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .client
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.client =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    15,
                                                    1,
                                                    15,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Designer
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    15,
                                                    2,
                                                    15,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .designer
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.designer =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    16,
                                                    1,
                                                    16,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Inspector User Name
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    16,
                                                    2,
                                                    16,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .inspector_username
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.inspector_username =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    17,
                                                    1,
                                                    17,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Main Contractor
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    17,
                                                    2,
                                                    17,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .main_contractor
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.main_contractor =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    18,
                                                    1,
                                                    18,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Sub Contractor
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    18,
                                                    2,
                                                    18,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .sub_contractor
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.sub_contractor =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    19,
                                                    1,
                                                    19,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    PSDP
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    19,
                                                    2,
                                                    19,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .psdp
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.psdp =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    20,
                                                    1,
                                                    20,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    PSCS{" "}
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    20,
                                                    2,
                                                    20,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .pscs
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.pscs =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    21,
                                                    1,
                                                    21,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    External Circulation{" "}
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    21,
                                                    2,
                                                    21,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_1
                                                            .external_circulation
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_1;
                                                        section.external_circulation =
                                                            event.target.value;
                                                        this.setState({
                                                            section_1: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                </StyledContent>

                                <Button
                                    style={{
                                        width: "150px",
                                        float: "right",
                                        backgroundColor: "#0188cc",
                                        marginRight: "17px",
                                        marginBottom: "24px",
                                    }}
                                    // disabled={
                                    //     this.state.report_details.report_title === "" && this.state.report_details.pass_score === ""
                                    //         ? true
                                    //         : false
                                    // }
                                    onClick={() => {
                                        if (
                                            this.state.report_details
                                                .report_title === "" ||
                                            this.state.report_details
                                                .pass_score === "" || 
                                            this.state.report_details.pass_score.includes(".") === true ||
                                            this.state.report_details.report_title.includes(".") === true ||
                                            this.state.report_details.report_title.includes("#") === true ||
                                            this.state.report_details.report_title.includes("$") === true ||
                                            this.state.report_details.report_title.includes("/") === true
                                        ) {
                                            this.setState({
                                                warningModal: true,
                                                warningMessage: 
                                                this.state.report_details.report_title === "" || this.state.report_details.pass_score === "" ?
                                                    "Template Title and Pass Percentage is mandatory to proceed further!!"
                                                    :
                                                    this.state.report_details.pass_score.includes(".") === true
                                                    ?
                                                    "Pass Percentage should always be whole number(Should not be decimal)"
                                                    :
                                                    this.state.report_details.report_title.includes(".") === true
                                                    ?
                                                    "Template Title should not include special characters like .,#,$,[,]"
                                                    :
                                                    this.state.report_details.report_title.includes("#") === true
                                                    ?
                                                    "Template Title should not include special characters like .,#,$,[,]"
                                                    :
                                                    this.state.report_details.report_title.includes("$") === true
                                                    ?
                                                    "Template Title should not include special characters like .,#,$,[,]"
                                                    :
                                                    this.state.report_details.report_title.includes("/") === true
                                                    ?
                                                    "Template Title should not include special characters like .,#,$,[,],/"
                                                    :
                                                    ""
                                            });
                                        } else {
                                            this.setState({
                                                isSection2: true,
                                            });
                                        }

                                        // this.setState({
                                        //     isSection2: true
                                        // });
                                    }}
                                >
                                    <b style={{ color: "white" }}>
                                        {" "}
                                        Work Details{" "}
                                    </b>
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.handleCloseModel();
                                        this.props.removeTemplate(
                                            this.state.report_details
                                                .report_title
                                        );
                                    }}
                                    style={{
                                        width: "150px",
                                        float: "right",
                                        backgroundColor: "#a9a5a5",
                                        marginRight: "20px",
                                        marginBottom: "24px",
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Card>
                        </>
                    ) : (
                        ""
                    )}
                    {this.state.isCreateTemplate === true &&
                    this.state.isSection2 === true ? (
                        <>
                            <br />
                            <br />
                            <Card>
                                <StyledHeader>
                                    <Typography variant="headline">
                                        Section 2 - Work Details
                                    </Typography>
                                </StyledHeader>
                                <StyledContent>
                                    <div
                                        style={{ width: "100%", clear: "both" }}
                                    >
                                        <div style={gstyle(5, 4, null, color)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "229px",
                                                    }}
                                                >
                                                    Work Status
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    2,
                                                    1,
                                                    3,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "150px",
                                                    }}
                                                >
                                                    Status
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    1,
                                                    2,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Estimated Man Hours
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    2,
                                                    2,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .estimated_man_hours
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.estimated_man_hours =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    1,
                                                    3,
                                                    2,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <b
                                                    style={{
                                                        paddingLeft: "200px",
                                                    }}
                                                >
                                                    Estimated Supervision Hours
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    2,
                                                    3,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .estimated_supervision_hours
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.estimated_supervision_hours =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={{
                                                    ...cstyle(
                                                        4,
                                                        1,
                                                        4,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        Worker Health Summary
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Details of any
                                                        work-related sickness or
                                                        absences)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    2,
                                                    4,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .worker_health_summary
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.worker_health_summary =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={{
                                                    ...cstyle(
                                                        5,
                                                        1,
                                                        5,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        Incident Summary
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Details of any Near
                                                        Miss, Minor Accidents,
                                                        Dangerous Occurrence,
                                                        Reportable Accidents)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    2,
                                                    5,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .incident_summary
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.incident_summary =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>

                                            <div
                                                style={{
                                                    ...cstyle(
                                                        6,
                                                        1,
                                                        6,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        Weeks Since Last
                                                        Incident
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (How many weeks since
                                                        last Near Miss, Minor
                                                        Accident, Dangerous
                                                        Occurrence, Reportable
                                                        Accident)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    6,
                                                    2,
                                                    6,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .weeks_since_last_incident
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.weeks_since_last_incident =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>

                                            <div
                                                style={{
                                                    ...cstyle(
                                                        7,
                                                        1,
                                                        7,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        First Aid Incidents
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Details of any first
                                                        aid treatment given or
                                                        received on site)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    7,
                                                    2,
                                                    7,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .first_aid_incidents
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.first_aid_incidents =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={{
                                                    ...cstyle(
                                                        8,
                                                        1,
                                                        8,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        SSWP/Toolbox Talks
                                                        Status
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Details/examples of
                                                        toolbox talks.
                                                        Compliance with SSWP
                                                        procedures)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    2,
                                                    8,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .sswp_toolbox_talks_status
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.sswp_toolbox_talks_status =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>

                                            <div
                                                style={{
                                                    ...cstyle(
                                                        9,
                                                        1,
                                                        9,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        PPE Status
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Summary on adequacy of
                                                        provision and use of
                                                        PPE)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    9,
                                                    2,
                                                    9,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .ppe_status
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.ppe_status =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>

                                            <div
                                                style={{
                                                    ...cstyle(
                                                        10,
                                                        1,
                                                        10,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        Safety Enforcement
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Details of improvement
                                                        instruction/
                                                        disciplinary action
                                                        issued to workers on
                                                        site)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    2,
                                                    10,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .safety_enforcement
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.safety_enforcement =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={{
                                                    ...cstyle(
                                                        11,
                                                        1,
                                                        11,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        Visitor Records{" "}
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Number of visitors to
                                                        the site over the last
                                                        period)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    2,
                                                    11,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .visitor_records
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.visitor_records =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={{
                                                    ...cstyle(
                                                        12,
                                                        1,
                                                        12,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        Pending Hazardous
                                                        Activities
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Summary highlight of
                                                        the most hazardous
                                                        activities (if any) for
                                                        the next period)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    2,
                                                    12,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .pending_hazardous_activities
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.pending_hazardous_activities =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                            <div
                                                style={{
                                                    ...cstyle(
                                                        13,
                                                        1,
                                                        13,
                                                        2,
                                                        false,
                                                        false
                                                    ),
                                                    display: "",
                                                }}
                                            >
                                                <div>
                                                    <b
                                                        style={{
                                                            paddingLeft:
                                                                "200px",
                                                        }}
                                                    >
                                                        HSQE Summary{" "}
                                                    </b>
                                                </div>
                                                <div>
                                                    <p
                                                        style={{
                                                            color: "black",
                                                            paddingLeft: "200px",
                                                            fontSize: "10px",
                                                        }}
                                                    >
                                                        (Overall summary of
                                                        inspection)
                                                    </p>
                                                </div>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    13,
                                                    2,
                                                    13,
                                                    3,
                                                    false,
                                                    false
                                                )}
                                            >
                                                <Select
                                                    style={{ width: "250px" }}
                                                    value={
                                                        this.state.section_2
                                                            .hsqe_summary
                                                    }
                                                    onChange={(event) => {
                                                        let section = this.state
                                                            .section_2;
                                                        section.hsqe_summary =
                                                            event.target.value;
                                                        this.setState({
                                                            section_2: section,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Yes">
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value="No">
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                </StyledContent>
                                <Button
                                    style={{
                                        width: "200px",
                                        float: "right",
                                        backgroundColor: "#0188cc",
                                        marginRight: "17px",
                                        marginBottom: "24px",
                                    }}
                                    onClick={() => {
                                        this.props.setReportDetails(
                                            this.state.report_details,
                                            (error) => {
                                                if (!error) {
                                                    this.props.setSection1(
                                                        this.state.section_1,
                                                        this.state
                                                            .report_details
                                                            .report_title,
                                                        (error) => {
                                                            if (!error) {
                                                                this.props.setSection2(
                                                                    this.state
                                                                        .section_2,
                                                                    this.state
                                                                        .report_details
                                                                        .report_title,
                                                                    (error) => {
                                                                        if (
                                                                            !error
                                                                        ) {
                                                                            return null;
                                                                        } else {
                                                                            return null;
                                                                        }
                                                                    }
                                                                );
                                                            } else {
                                                                return false;
                                                            }
                                                        }
                                                    );
                                                } else {
                                                    return false;
                                                }
                                            }
                                        );
                                        this.props.getGroups(
                                            this.state.report_details
                                                .report_title
                                        );
                                        this.setState({
                                            isTitleEntered: true,
                                            isSection3: true,
                                        });
                                    }}
                                >
                                    <b style={{ color: "white" }}>
                                        {" "}
                                        Inspection Items{" "}
                                    </b>
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.handleCloseModel();
                                        this.props.removeTemplate(
                                            this.state.report_details
                                                .report_title
                                        );
                                    }}
                                    style={{
                                        width: "150px",
                                        float: "right",
                                        backgroundColor: "#a9a5a5",
                                        marginRight: "20px",
                                        marginBottom: "24px",
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Card>
                        </>
                    ) : (
                        ""
                    )}
                    {this.state.isCreateTemplate === true &&
                    this.state.isSection3 === true ? (
                        <>
                            <br />
                            <br />
                            <Card>
                                <StyledHeader>
                                    <Typography variant="headline">
                                        Section 3 - Inspection Items
                                    </Typography>
                                </StyledHeader>
                                <StyledContent>
                                    <div>
                                        <Table>
                                            <TableBody>
                                                {groups &&
                                                    groups.map((e, i) => {
                                                        return (
                                                            <TableRow key={i}>
                                                                <div
                                                                    className="icon-text-container"
                                                                    style={{
                                                                        borderWidth:
                                                                            "medium",
                                                                        border:
                                                                            "7px solid #0188cc",
                                                                        borderRadius:
                                                                            "9px",
                                                                        marginTop:
                                                                            "22px",
                                                                    }}
                                                                >
                                                                    <div>
                                                                        <h5
                                                                            style={{
                                                                                width:
                                                                                    "100%",
                                                                                marginTop:
                                                                                    "7px",
                                                                                marginLeft:
                                                                                    "7px",
                                                                            }}
                                                                        >
                                                                            Group
                                                                            Name:{" "}
                                                                            <span className="subHeading">
                                                                                {
                                                                                    e
                                                                                        .profile
                                                                                        .group_name
                                                                                }
                                                                            </span>
                                                                        </h5>
                                                                    </div>
                                                                    <div
                                                                        className="float-left text-container"
                                                                        style={{
                                                                            display:
                                                                                "flex",
                                                                            width:
                                                                                "100%",
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            <h5
                                                                                style={{
                                                                                    border:
                                                                                        "2px solid #0188cc",
                                                                                    marginLeft:
                                                                                        "15px",
                                                                                    borderRadius:
                                                                                        "12px",
                                                                                    padding:
                                                                                        "7px",
                                                                                    textAlign:
                                                                                        "center",
                                                                                    width:
                                                                                        "370px",
                                                                                }}
                                                                            >
                                                                                <b>
                                                                                    Group
                                                                                    Weight:
                                                                                </b>{" "}
                                                                                <span className="subHeading">
                                                                                    {
                                                                                        e
                                                                                            .profile
                                                                                            .group_weight
                                                                                    }
                                                                                </span>
                                                                            </h5>
                                                                        </span>
                                                                        <span>
                                                                            <IconButton
                                                                                style={{
                                                                                    color:
                                                                                        "#0188cc",
                                                                                    border:
                                                                                        "1px solid #0188cc",
                                                                                    marginLeft:
                                                                                        "70px",
                                                                                    float:
                                                                                        "right",
                                                                                    marginTop:
                                                                                        "0px",
                                                                                }}
                                                                                onClick={() => {
                                                                                    let countReference = parseInt(
                                                                                        e
                                                                                            .profile
                                                                                            .group_weight,
                                                                                        10
                                                                                    );
                                                                                    this.setState(
                                                                                        {
                                                                                            editUID:
                                                                                                e
                                                                                                    .profile
                                                                                                    .group_id,
                                                                                            new_group:
                                                                                                e.profile,
                                                                                            editGroupModal: true,
                                                                                            prevGroupCount: this
                                                                                                .state
                                                                                                .groupCount,
                                                                                            groupCount:
                                                                                                this
                                                                                                    .state
                                                                                                    .groupCount -
                                                                                                countReference,
                                                                                        }
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <EditIcon />
                                                                            </IconButton>
                                                                        </span>
                                                                        {this
                                                                            .state
                                                                            .itemCount ===
                                                                        100 ? (
                                                                            <span>
                                                                                <IconButton
                                                                                    style={{
                                                                                        color:
                                                                                            "red",
                                                                                        border:
                                                                                            "1px solid red",
                                                                                        marginLeft:
                                                                                            "10px",
                                                                                        float:
                                                                                            "right",
                                                                                        marginTop:
                                                                                            "0px",
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        this.setState(
                                                                                            {
                                                                                                editUID:
                                                                                                    e
                                                                                                        .profile
                                                                                                        .group_id,
                                                                                                new_group:
                                                                                                    e.profile,
                                                                                                deleteGroupModal: true,
                                                                                            }
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </span>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </div>
                                                                    <div>
                                                                        <Button
                                                                            style={{
                                                                                backgroundColor:
                                                                                    "#0188CC",
                                                                                color:
                                                                                    "white",
                                                                                marginLeft:
                                                                                    "10px",
                                                                                marginBottom:
                                                                                    "10px",
                                                                            }}
                                                                            variant="contained"
                                                                            disabled={
                                                                                e
                                                                                    .profile
                                                                                    .group_id ===
                                                                                this
                                                                                    .state
                                                                                    .groupIdReference -
                                                                                    1
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        itemAddGroupName:
                                                                                            e
                                                                                                .profile
                                                                                                .group_name,
                                                                                        itemAddGroupId:
                                                                                            e
                                                                                                .profile
                                                                                                .group_id,
                                                                                        newItemModal: true,
                                                                                    }
                                                                                );
                                                                            }}
                                                                        >
                                                                            Add
                                                                            Item
                                                                        </Button>
                                                                    </div>

                                                                    {e.items &&
                                                                    e.items
                                                                        .length !==
                                                                        0 ? (
                                                                        <div>
                                                                            <Card>
                                                                                <StyledHeader
                                                                                    style={{
                                                                                        padding:
                                                                                            "0px",
                                                                                        backgroundColor:
                                                                                            "#0188CC",
                                                                                        marginLeft:
                                                                                            "5px",
                                                                                        marginRight:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    <Typography
                                                                                        variant="headline"
                                                                                        style={{
                                                                                            textAlign:
                                                                                                "center",
                                                                                            color:
                                                                                                "white",
                                                                                            marginLeft: "5px"
                                                                                        }}
                                                                                    >
                                                                                        Items
                                                                                        List
                                                                                    </Typography>
                                                                                </StyledHeader>
                                                                            </Card>
                                                                        </div>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    <div>
                                                                        <Table>
                                                                            <TableBody>
                                                                                {e.items &&
                                                                                    e.items.map(
                                                                                        (
                                                                                            k,
                                                                                            j
                                                                                        ) => {
                                                                                            return (
                                                                                                <TableRow
                                                                                                    key={
                                                                                                        j
                                                                                                    }
                                                                                                >
                                                                                                    <div
                                                                                                        className="icon-text-container"
                                                                                                        style={{
                                                                                                            borderWidth:
                                                                                                                "medium",
                                                                                                            border:
                                                                                                                "2px solid #0188cc",
                                                                                                            borderRadius:
                                                                                                                "9px",
                                                                                                            marginTop:
                                                                                                                "22px",
                                                                                                            marginLeft:
                                                                                                                "10px",
                                                                                                            marginRight:
                                                                                                                "10px",
                                                                                                            marginBottom:
                                                                                                                "10px",
                                                                                                        }}
                                                                                                    >
                                                                                                        <div>
                                                                                                            <h5
                                                                                                                style={{
                                                                                                                    marginLeft:
                                                                                                                        "10px",
                                                                                                                    padding:
                                                                                                                        "7px",
                                                                                                                    textAlign:
                                                                                                                        "left",
                                                                                                                }}
                                                                                                            >
                                                                                                                <b>
                                                                                                                    Item
                                                                                                                    Name:
                                                                                                                </b>{" "}
                                                                                                                <span className="subHeading">
                                                                                                                    {
                                                                                                                        k.item_name
                                                                                                                    }
                                                                                                                </span>
                                                                                                            </h5>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            className="float-left text-container"
                                                                                                            style={{
                                                                                                                display:
                                                                                                                    "flex",
                                                                                                            }}
                                                                                                        >
                                                                                                            <span>
                                                                                                                <h5
                                                                                                                    style={{
                                                                                                                        border:
                                                                                                                            "2px solid #0188cc",
                                                                                                                        marginLeft:
                                                                                                                            "15px",
                                                                                                                        borderRadius:
                                                                                                                            "12px",
                                                                                                                        padding:
                                                                                                                            "7px",
                                                                                                                        textAlign:
                                                                                                                            "center",
                                                                                                                        width:
                                                                                                                            "250px",
                                                                                                                        marginTop:
                                                                                                                            "14px",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        Item
                                                                                                                        Weight:
                                                                                                                    </b>{" "}
                                                                                                                    <span className="subHeading">
                                                                                                                        {
                                                                                                                            k.item_weight
                                                                                                                        }
                                                                                                                    </span>
                                                                                                                </h5>
                                                                                                            </span>
                                                                                                            <span>
                                                                                                                <h5
                                                                                                                    style={{
                                                                                                                        border:
                                                                                                                            "2px solid #0188cc",
                                                                                                                        marginLeft:
                                                                                                                            "10px",
                                                                                                                        borderRadius:
                                                                                                                            "12px",
                                                                                                                        padding:
                                                                                                                            "7px",
                                                                                                                        textAlign:
                                                                                                                            "center",
                                                                                                                        width:
                                                                                                                            "250px",
                                                                                                                        marginTop:
                                                                                                                            "14px",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <b>
                                                                                                                        {" "}
                                                                                                                        Response
                                                                                                                        Level:
                                                                                                                    </b>{" "}
                                                                                                                    <span className="subHeading">
                                                                                                                        {
                                                                                                                            k.item_response_class
                                                                                                                        }
                                                                                                                    </span>
                                                                                                                </h5>
                                                                                                            </span>
                                                                                                            {e
                                                                                                                .profile
                                                                                                                .group_id ===
                                                                                                            this
                                                                                                                .state
                                                                                                                .groupIdReference -
                                                                                                                1 ? (
                                                                                                                <span>
                                                                                                                    <IconButton
                                                                                                                        style={{
                                                                                                                            color:
                                                                                                                                "#0188cc",
                                                                                                                            border:
                                                                                                                                "1px solid #0188cc",
                                                                                                                            marginLeft:
                                                                                                                                "70px",
                                                                                                                            float:
                                                                                                                                "right",
                                                                                                                            marginTop:
                                                                                                                                "14px",
                                                                                                                        }}
                                                                                                                        onClick={() => {
                                                                                                                            let countReference = parseInt(
                                                                                                                                k.item_weight,
                                                                                                                                10
                                                                                                                            );
                                                                                                                            this.setState(
                                                                                                                                {
                                                                                                                                    editUID:
                                                                                                                                        e
                                                                                                                                            .profile
                                                                                                                                            .group_id,
                                                                                                                                    new_item: k,

                                                                                                                                    editItemModal: true,
                                                                                                                                    prevItemCount: this
                                                                                                                                        .state
                                                                                                                                        .itemCount,
                                                                                                                                    itemCount:
                                                                                                                                        this
                                                                                                                                            .state
                                                                                                                                            .itemCount -
                                                                                                                                        countReference,
                                                                                                                                }
                                                                                                                            );
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <EditIcon />
                                                                                                                    </IconButton>
                                                                                                                </span>
                                                                                                            ) : (
                                                                                                                ""
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <div className="clear"></div>
                                                                                                    </div>
                                                                                                </TableRow>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </div>

                                                                    <div className="clear"></div>
                                                                </div>
                                                            </TableRow>
                                                        );
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </div>
                                    {this.state.groupCount === 0 ? (
                                        <Button
                                            onClick={() => {
                                                this.handleNewGroupModal();
                                            }}
                                            style={{
                                                backgroundColor: "#0188CC",
                                                color: "white",
                                                marginTop: "16px",
                                            }}
                                            variant="contained"
                                        >
                                            Add Group
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={() => {
                                                if (
                                                    this.state.itemCount === 100
                                                ) {
                                                    this.handleNewGroupModal();
                                                    this.setState({
                                                        itemCount: 0,
                                                    });
                                                } else {
                                                    this.setState({
                                                        warningModal: true,
                                                        warningMessage: `The total Item Weights must total to 100 in the last group that you created!!! Currently last group Item Weight is ${this.state.itemCount}`,
                                                    });
                                                }
                                            }}
                                            style={{
                                                backgroundColor: "#0188CC",
                                                color: "white",
                                                marginTop: "16px",
                                            }}
                                            variant="contained"
                                        >
                                            Add Group
                                        </Button>
                                    )}
                                </StyledContent>
                                <Button
                                    style={{
                                        width: "150px",
                                        float: "right",
                                        backgroundColor: "#0188cc",
                                        marginRight: "17px",
                                        marginBottom: "24px",
                                    }}
                                    // disabled={
                                    //     this.state.groupCount === 100 && this.state.itemCount === 100
                                    //         ? false
                                    //         : true
                                    // }

                                    onClick={() => {
                                        if (
                                            this.state.groupCount === 100 &&
                                            this.state.itemCount === 100
                                        ) {
                                            let reportTitle = this.state
                                                .report_details;
                                            reportTitle.deleted = false;
                                            this.setState({
                                                report_details: reportTitle,
                                            });
                                            this.props.setReportDetails(
                                                this.state.report_details,
                                                (error) => {
                                                    if (!error) {
                                                        this.props.setSection1(
                                                            this.state
                                                                .section_1,
                                                            this.state
                                                                .report_details
                                                                .report_title,
                                                            (error) => {
                                                                if (!error) {
                                                                    this.props.setSection2(
                                                                        this
                                                                            .state
                                                                            .section_2,
                                                                        this
                                                                            .state
                                                                            .report_details
                                                                            .report_title,
                                                                        (
                                                                            error
                                                                        ) => {
                                                                            if (
                                                                                !error
                                                                            ) {
                                                                                this.handleCloseModel();
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        }
                                                                    );
                                                                } else {
                                                                    return false;
                                                                }
                                                            }
                                                        );
                                                    } else {
                                                        return false;
                                                    }
                                                }
                                            );
                                        } else {
                                            this.setState({
                                                warningModal: true,
                                                warningMessage: `The Total Group Weights and all Item Weights inside every group must total to 100 to submit the template !!! Current Template total Group Weight is ${this.state.groupCount}`,
                                            });
                                        }
                                    }}
                                >
                                    <b style={{ color: "white" }}>Submit</b>
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.handleCloseModel();
                                        this.props.removeTemplate(
                                            this.state.report_details
                                                .report_title
                                        );
                                    }}
                                    style={{
                                        width: "150px",
                                        float: "right",
                                        backgroundColor: "#a9a5a5",
                                        marginRight: "20px",
                                        marginBottom: "24px",
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Card>
                        </>
                    ) : (
                        ""
                    )}
                    {/* --------------------------------------Add Group Modal---------------------------- */}
                    <div>
                        <Modal isOpen={this.state.newGroupModal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Add Group
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Group Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                value={
                                                    this.state.new_group
                                                        .group_name
                                                }
                                                placeholder="Group Name"
                                                onChange={(event) => {
                                                    let newGroup = this.state
                                                        .new_group;
                                                    newGroup.group_name =
                                                        event.target.value;
                                                    this.setState({
                                                        new_group: newGroup,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Group Weight&nbsp;:&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                type="number"
                                                helperText="Group Weight should always be whole number"
                                                value={
                                                    this.state.new_group
                                                        .group_weight
                                                }
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                placeholder="Group Weight"
                                                onChange={(event) => {
                                                    let newGroup = this.state
                                                        .new_group;
                                                    newGroup.group_weight =
                                                        event.target.value;
                                                    this.setState({
                                                        new_group: newGroup,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                newGroupModal: false,
                                                group_name: "",
                                                group_weight: "",
                                                group_id: "",
                                                itemCount: 100,
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            let countReference = parseInt(
                                                this.state.new_group
                                                    .group_weight,
                                                10
                                            );
                                            this.handleCount(
                                                "add",
                                                this.state.groupIdReference
                                            );
                                            this.setId(
                                                this.state.groupIdReference
                                            );
                                            this.props.addGroup(
                                                this.state.new_group,
                                                this.state.groupIdReference,
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.props.getGroups(
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.setState({
                                                groupCount:
                                                    this.state.groupCount +
                                                    countReference,
                                                newGroupModal: false,
                                                itemAddGroupId: "",
                                                itemAddGroupName: "",
                                                group_name: "",
                                                group_weight: "",
                                                itemIdReference: 0,
                                                group_id: "",
                                            });
                                        }}
                                        disabled={
                                            this.state.new_group.group_name === "" ||
                                            this.state.new_group.group_weight === "" ||
                                            this.state.new_group.group_weight.includes(".") === true
                                                ? true
                                                : false
                                        }
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* --------------------------------------Edit Group Modal---------------------------- */}
                    <div>
                        <Modal isOpen={this.state.editGroupModal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Edit Group
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Group Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                value={
                                                    this.state.new_group
                                                        .group_name
                                                }
                                                placeholder="Group Name"
                                                onChange={(event) => {
                                                    let newGroup = this.state
                                                        .new_group;
                                                    newGroup.group_name =
                                                        event.target.value;
                                                    this.setState({
                                                        new_group: newGroup,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Group Weight&nbsp;:&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                type="number"
                                                helperText="Group Weight should always be whole number"
                                                value={
                                                    this.state.new_group
                                                        .group_weight
                                                }
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                placeholder="Group Weight"
                                                onChange={(event) => {
                                                    let newGroup = this.state
                                                        .new_group;
                                                    newGroup.group_weight =
                                                        event.target.value;
                                                    this.setState({
                                                        new_group: newGroup,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                editGroupModal: false,
                                                group_name: "",
                                                group_weight: "",
                                                group_id: "",
                                                editUID: "",
                                                groupCount: this.state
                                                    .prevGroupCount,
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        disabled={
                                            this.state.new_group.group_name === "" ||
                                            this.state.new_group.group_weight === "" ||
                                            this.state.new_group.group_weight.includes(".") === true
                                                ? true
                                                : false
                                        }
                                        onClick={() => {
                                            let countReference = parseInt(
                                                this.state.new_group
                                                    .group_weight,
                                                10
                                            );
                                            this.props.editGroup(
                                                this.state.new_group,
                                                this.state.editUID,
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.props.getGroups(
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.setState({
                                                editGroupModal: false,
                                                group_name: "",
                                                group_weight: "",
                                                group_id: "",
                                                editUID: "",
                                                groupCount:
                                                    this.state.groupCount +
                                                    countReference,
                                            });
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* --------------------------------------Remove Group Modal---------------------------- */}
                    <div>
                        <Modal isOpen={this.state.deleteGroupModal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Remove Group
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <p>
                                                <b>
                                                    Are you sure you want to
                                                    delete this group from
                                                    Inspection items?
                                                </b>
                                            </p>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Group Name&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.new_group
                                                            .group_name
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Group Weight&nbsp;:&nbsp;
                                                <b>
                                                    {
                                                        this.state.new_group
                                                            .group_weight
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                deleteGroupModal: false,
                                                group_name: "",
                                                group_weight: "",
                                                group_id: "",
                                                editUID: "",
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            let countReference = parseInt(
                                                this.state.new_group
                                                    .group_weight,
                                                10
                                            );
                                            this.props.removeGroup(
                                                this.state.editUID,
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.props.getGroups(
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.setState({
                                                deleteGroupModal: false,
                                                group_name: "",
                                                group_weight: "",
                                                group_id: "",
                                                editUID: "",
                                                groupCount:
                                                    this.state.groupCount -
                                                    countReference,
                                            });
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* -----------------------------------Add Item Modal---------------------------- */}
                    <div>
                        <Modal isOpen={this.state.newItemModal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Add Items to the Group
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Group Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {this.state.itemAddGroupName}
                                            </span>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Item Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                value={
                                                    this.state.new_item
                                                        .item_name
                                                }
                                                placeholder="Item Name"
                                                onChange={(event) => {
                                                    let newItem = this.state
                                                        .new_item;
                                                    newItem.item_name =
                                                        event.target.value;
                                                    this.setState({
                                                        new_item: newItem,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Item Weight&nbsp;:&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                type="number"
                                                helperText="Item Weight should always be whole number"
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                value={
                                                    this.state.new_item
                                                        .item_weight
                                                }
                                                placeholder="Item Weight"
                                                onChange={(event) => {
                                                    let newItem = this.state
                                                        .new_item;
                                                    newItem.item_weight =
                                                        event.target.value;
                                                    this.setState({
                                                        new_item: newItem,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Item Response Level&nbsp;:&nbsp;
                                            </Label>
                                            <Select
                                                value={
                                                    this.state.new_item
                                                        .item_response_class
                                                }
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "200px",
                                                }}
                                                onChange={(event) => {
                                                    let newItem = this.state
                                                        .new_item;
                                                    newItem.item_response_class =
                                                        event.target.value;
                                                    this.setState({
                                                        new_item: newItem,
                                                    });
                                                }}
                                            >
                                                <MenuItem value="1">1</MenuItem>
                                                <MenuItem value="2">2</MenuItem>
                                                <MenuItem value="3">3</MenuItem>
                                                <MenuItem value="4">4</MenuItem>
                                                <MenuItem value="5">5</MenuItem>
                                            </Select>
                                            <span>
                                                <IconButton
                                                    style={{
                                                        color: "#0188cc",
                                                        marginTop: "-7px",
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            responseInfoModal: true,
                                                        });
                                                    }}
                                                >
                                                    <InfoIcon />
                                                </IconButton>
                                            </span>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                new_item: {
                                                    item_name: "",
                                                    item_weight: "",
                                                    item_response_class: "",
                                                    item_id: "",
                                                },
                                                itemAddGroupId: "",
                                                itemAddGroupName: "",
                                                newItemModal: false,
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        disabled={
                                            this.state.new_item.item_name ==="" ||
                                            this.state.new_item.item_weight ==="" ||
                                            this.state.new_item.item_response_class === "" ||
                                            this.state.new_item.item_weight.includes(".") === true
                                                ? true
                                                : false
                                        }
                                        onClick={() => {
                                            let countReference = parseInt(
                                                this.state.new_item.item_weight,
                                                10
                                            );
                                            this.handleItemCount(
                                                "add",
                                                this.state.itemIdReference
                                            );
                                            this.setItemId(
                                                this.state.itemIdReference
                                            );
                                            this.props.addItem(
                                                this.state.new_item,
                                                this.state.itemIdReference,
                                                this.state.itemAddGroupId,
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.props.getGroups(
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.setState({
                                                itemCount:
                                                    this.state.itemCount +
                                                    countReference,
                                                new_item: {
                                                    item_name: "",
                                                    item_weight: "",
                                                    item_response_class: "",
                                                    item_id: "",
                                                },
                                                itemAddGroupName: "",
                                                itemAddGroupId: "",
                                                newItemModal: false,
                                            });
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* --------------------------------------Edit Item Modal---------------------------- */}
                    <div>
                        <Modal isOpen={this.state.editItemModal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Edit Item
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                &nbsp;Item
                                                Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                value={
                                                    this.state.new_item
                                                        .item_name
                                                }
                                                placeholder="Group Name"
                                                onChange={(event) => {
                                                    let newItem = this.state
                                                        .new_item;
                                                    newItem.item_name =
                                                        event.target.value;
                                                    this.setState({
                                                        new_item: newItem,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                &nbsp;Item Weight&nbsp;:&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                type="number"
                                                helperText="Item Weight should always be whole number"
                                                value={
                                                    this.state.new_item
                                                        .item_weight
                                                }
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                }}
                                                placeholder="Group Weight"
                                                onChange={(event) => {
                                                    let newItem = this.state
                                                        .new_item;
                                                    newItem.item_weight =
                                                        event.target.value;
                                                    this.setState({
                                                        new_item: newItem,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Col>
                                                <Label for="name">
                                                    Item Response
                                                    Level&nbsp;:&nbsp;
                                                </Label>
                                                <Select
                                                    value={
                                                        this.state.new_item
                                                            .item_response_class
                                                    }
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                        marginBottom: "11px",
                                                        width: "200px",
                                                    }}
                                                    onChange={(event) => {
                                                        let newItem = this.state
                                                            .new_item;
                                                        newItem.item_response_class =
                                                            event.target.value;
                                                        this.setState({
                                                            new_item: newItem,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="1">
                                                        1
                                                    </MenuItem>
                                                    <MenuItem value="2">
                                                        2
                                                    </MenuItem>
                                                    <MenuItem value="3">
                                                        3
                                                    </MenuItem>
                                                    <MenuItem value="4">
                                                        4
                                                    </MenuItem>
                                                    <MenuItem value="5">
                                                        5
                                                    </MenuItem>
                                                </Select>
                                            </Col>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                editItemModal: false,
                                                editUID: "",
                                                new_item: {
                                                    item_name: "",
                                                    item_weight: "",
                                                    item_response_class: "",
                                                    item_id: "",
                                                },
                                                itemCount: this.state
                                                    .prevItemCount,
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        disabled={
                                            this.state.new_item.item_name ==="" ||
                                            this.state.new_item.item_weight ==="" ||
                                            this.state.new_item.item_response_class === "" ||
                                            this.state.new_item.item_weight.includes(".") === true
                                                ? true
                                                : false
                                        }
                                        onClick={() => {
                                            let countReference = parseInt(
                                                this.state.new_item.item_weight,
                                                10
                                            );
                                            this.props.editItem(
                                                this.state.new_item,
                                                this.state.editUID,
                                                this.state.new_item.item_id,
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.props.getGroups(
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.setState({
                                                editItemModal: false,
                                                editUID: "",
                                                new_item: {
                                                    item_name: "",
                                                    item_weight: "",
                                                    item_response_class: "",
                                                    item_id: "",
                                                },
                                                itemCount:
                                                    this.state.itemCount +
                                                    countReference,
                                            });
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* ----------------------------------------Archieve Template Modal ----------------------- */}
                    {/* <div>
                        <Modal
                            isOpen={this.state.deleteTemplateModal}
                        >
                            <StyledHeader>
                                <Typography variant="headline">
                                    Remove Template
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <p><b>Are you sure you want to delete this Inspection Template?</b></p>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Template Name&nbsp;:&nbsp;&nbsp; <b>{this.state.report_details.report_title}</b>
                                            </Label>

                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                deleteTemplateModal: false,
                                            });
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "red", color: "white" }}
                                        onClick={() => {
                                            this.setState({
                                                deleteTemplateModal: false,

                                            });
                                            this.props.removeTemplate(this.state.report_details.report_title)
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div> */}

                    {/* ----------------------------------------Archieve Template Modal ----------------------- */}
                    <div>
                        <Modal isOpen={this.state.deleteTemplateModal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Remove Template
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <p>
                                                <b>
                                                    Are you sure you want to
                                                    delete this Inspection
                                                    Template?
                                                </b>
                                            </p>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Template Name&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state
                                                            .report_details
                                                            .report_title
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                deleteTemplateModal: false,
                                            });
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "red",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                deleteTemplateModal: false,
                                            });
                                            this.props.templateCopy(
                                                this.state.report_details
                                                    .report_title,
                                                copyTemp,
                                                "report_templates_archieve"
                                            );
                                            this.props.removeTemplate(
                                                this.state.report_details
                                                    .report_title
                                            );
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>

                    {/* //------------Warning modal---------------------- */}
                    <Modal isOpen={this.state.warningModal}>
                        <StyledHeader>
                            <Typography
                                variant="headline"
                                style={{ color: "red" }}
                            >
                                Warning!!!
                            </Typography>
                        </StyledHeader>
                        <StyledContent>
                            <ModalBody>
                                <ModalRow>
                                    <Col>
                                        <p>
                                            <b style={{ fontSize: "12px" }}>
                                                {this.state.warningMessage}
                                            </b>
                                        </p>
                                    </Col>
                                </ModalRow>
                            </ModalBody>
                        </StyledContent>
                        <ModalFooter>
                            <div>
                                {/* <Button
                                onClick={() => {
                                    this.setState({
                                        warningModal: false,
                                        warningMessage:""
                                    });
                                }}
                            >
                                Cancel
                                    </Button> */}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{
                                        backgroundColor: "#ce3939",
                                        color: "white",
                                    }}
                                    onClick={() => {
                                        this.setState({
                                            warningModal: false,
                                            warningMessage: "",
                                        });
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </ModalFooter>
                    </Modal>

                    {/* // ------------------------Section 1 Modal ---------------- */}
                    <div>
                        <Modal isOpen={this.state.section1Modal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Inspection Details
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Inspection
                                                Location&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .inspection_location
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Inspection
                                                Timestamp&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .inspection_timestamp
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Inspector User
                                                Name&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .inspector_username
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Inspection
                                                Reps&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .inspection_reps
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Project ID&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .project_id
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Project Title&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .project_title
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Work Location&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .work_location
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Works
                                                Description&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .works_description
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Weather
                                                Conditions&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .weather_conditions
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Light
                                                Conditions&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .light_conditions
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Visibility&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .visibility
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Surface
                                                Conditions&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .surface_conditions
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Working Close to the
                                                public&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .working_close_to_the_public
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Client&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .client
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Designer&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .designer
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Main
                                                Contractor&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .main_contractor
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Sub
                                                Contractor&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .sub_contractor
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                PSDP&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {this.state.section_1.psdp}
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                PSCS&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {this.state.section_1.pscs}
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                External
                                                Circulation&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_1
                                                            .external_circulation
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* // ------------------------Section 2 Modal ---------------- */}
                    <div>
                        <Modal isOpen={this.state.section2Modal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Work Details
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Estimated Man
                                                Hours&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .estimated_man_hours
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Estimated Supervision
                                                Hours&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .estimated_supervision_hours
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Worker Health Summary
                                                &nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .worker_health_summary
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Incident
                                                Summary&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .incident_summary
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Weeks Since Last
                                                Incident&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .weeks_since_last_incident
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                First Aid
                                                Incidents&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .first_aid_incidents
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                SSWP/Toolbox Talks
                                                Status&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .sswp_toolbox_talks_status
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                PPE Status&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .ppe_status
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Safety
                                                Enforcement&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .safety_enforcement
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Visitor
                                                Records&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .visitor_records
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Pending Hazardous
                                                Activities&nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .pending_hazardous_activities
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                HSQE Summary &nbsp;:&nbsp;&nbsp;{" "}
                                                <b>
                                                    {
                                                        this.state.section_2
                                                            .hsqe_summary
                                                    }
                                                </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* // ------------------------Section 3 Modal ---------------- */}
                    <div>
                        <Modal isOpen={this.state.section3Modal}>
                            <StyledHeader>
                                <Typography variant="headline">
                                    Inspection Details
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <h3
                                            style={{
                                                textAlign: "center",
                                                backgroundColor: "#0188cc",
                                                padding: "4px",
                                                fontWeight: "bold",
                                                color: "white",
                                                marginLeft: "140px",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            Group Details
                                        </h3>
                                        <div>
                                            <Table>
                                                <TableBody>
                                                    {groups &&
                                                        groups.map((e, i) => {
                                                            return (
                                                                <TableRow
                                                                    key={i}
                                                                >
                                                                    <div
                                                                        className="icon-text-container"
                                                                        style={{
                                                                            borderWidth:
                                                                                "medium",
                                                                            border:
                                                                                "7px solid #0188cc",
                                                                            borderRadius:
                                                                                "9px",
                                                                            marginTop:
                                                                                "10px",
                                                                            width:
                                                                                "460px",
                                                                        }}
                                                                    >
                                                                        <div>
                                                                            <h5
                                                                                style={{
                                                                                    padding:
                                                                                        "7px",
                                                                                    textAlign:
                                                                                        "left",
                                                                                    width:
                                                                                        "100%",
                                                                                    fontSize:
                                                                                        "1em",
                                                                                    wordBreak:
                                                                                        "breakword",
                                                                                }}
                                                                            >
                                                                                <b>
                                                                                    Group
                                                                                    Name:
                                                                                </b>{" "}
                                                                                <span className="subHeading">
                                                                                    {
                                                                                        e
                                                                                            .profile
                                                                                            .group_name
                                                                                    }
                                                                                </span>
                                                                            </h5>
                                                                        </div>
                                                                        <div>
                                                                            <h5
                                                                                style={{
                                                                                    padding:
                                                                                        "7px",
                                                                                    textAlign:
                                                                                        "left",
                                                                                    width:
                                                                                        "100%",
                                                                                    fontSize:
                                                                                        "1em",
                                                                                    wordBreak:
                                                                                        "breakword",
                                                                                }}
                                                                            >
                                                                                <b>
                                                                                    Group
                                                                                    Weight:
                                                                                </b>{" "}
                                                                                <span className="subHeading">
                                                                                    {
                                                                                        e
                                                                                            .profile
                                                                                            .group_weight
                                                                                    }
                                                                                </span>
                                                                            </h5>
                                                                        </div>
                                                                        <div>
                                                                            <div>
                                                                                <Table>
                                                                                    <TableBody>
                                                                                        <p
                                                                                            style={{
                                                                                                textAlign:
                                                                                                    "center",
                                                                                                backgroundColor:
                                                                                                    "#c7c7cc",
                                                                                                paddingTop:
                                                                                                    "4px",
                                                                                                paddingBottom:
                                                                                                    "4px",
                                                                                                fontWeight:
                                                                                                    "bold",
                                                                                            }}
                                                                                        >
                                                                                            Item
                                                                                            List
                                                                                        </p>
                                                                                        {e.items &&
                                                                                            e.items.map(
                                                                                                (
                                                                                                    k,
                                                                                                    j
                                                                                                ) => {
                                                                                                    return (
                                                                                                        <TableRow>
                                                                                                            <div
                                                                                                                className="icon-text-container"
                                                                                                                style={{
                                                                                                                    borderWidth:
                                                                                                                        "medium",
                                                                                                                    border:
                                                                                                                        "2px solid #0188cc",
                                                                                                                    borderRadius:
                                                                                                                        "9px",
                                                                                                                    marginTop:
                                                                                                                        "10px",
                                                                                                                    marginLeft:
                                                                                                                        "10px",
                                                                                                                    marginRight:
                                                                                                                        "10px",
                                                                                                                    marginBottom:
                                                                                                                        "10px",
                                                                                                                }}
                                                                                                            >
                                                                                                                <p>
                                                                                                                    <b>
                                                                                                                        Item
                                                                                                                        Name:&nbsp;
                                                                                                                    </b>
                                                                                                                    {
                                                                                                                        k.item_name
                                                                                                                    }
                                                                                                                </p>
                                                                                                                <p>
                                                                                                                    <b>
                                                                                                                        Item
                                                                                                                        Weight:&nbsp;
                                                                                                                    </b>
                                                                                                                    {
                                                                                                                        k.item_weight
                                                                                                                    }{" "}
                                                                                                                </p>
                                                                                                                <p>
                                                                                                                    <b>
                                                                                                                        Item
                                                                                                                        Class:&nbsp;
                                                                                                                    </b>{" "}
                                                                                                                    {
                                                                                                                        k.item_response_class
                                                                                                                    }
                                                                                                                </p>
                                                                                                                <div className="clear"></div>
                                                                                                            </div>
                                                                                                        </TableRow>
                                                                                                    );
                                                                                                }
                                                                                            )}
                                                                                    </TableBody>
                                                                                </Table>
                                                                            </div>
                                                                        </div>
                                                                        <div className="clear"></div>
                                                                    </div>
                                                                </TableRow>
                                                            );
                                                        })}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "#0188CC",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* ------------------------------------------------------------------- */}
                    {/* response info modal */}
                    <InfoModal
                        isOpen={this.state.responseInfoModal}
                        style={{ width: "117%" }}
                    >
                        <InfoPaper>
                            <StyledCard>
                                <StyledHeader>
                                    <Typography
                                        variant="headline"
                                        style={{
                                            textAlign: "center",
                                            fontSize: "1.2em",
                                        }}
                                    >
                                        Response Class Info
                                    </Typography>
                                </StyledHeader>
                            </StyledCard>
                            <p
                                style={{
                                    textAlign: "center",
                                    backgroundColor: "#c7c7cc",
                                    paddingTop: "4px",
                                    paddingBottom: "4px",
                                    fontWeight: "bold",
                                }}
                            >
                                Response Level
                            </p>
                            <InfoDiv>
                                <img
                                    src={responseLevel}
                                    alt={"alt"}
                                    style={{
                                        width: "248px",
                                        marginLeft: "56px",
                                    }}
                                />
                            </InfoDiv>
                            <p
                                style={{
                                    textAlign: "center",
                                    backgroundColor: "#c7c7cc",
                                    paddingTop: "4px",
                                    paddingBottom: "4px",
                                    fontWeight: "bold",
                                }}
                            >
                                Response Matrix
                            </p>
                            <InfoDiv>
                                <img
                                    src={responseLevel2}
                                    alt={"alt"}
                                    style={{
                                        width: "457px",
                                    }}
                                />
                            </InfoDiv>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    this.setState({
                                        responseInfoModal: false,
                                    });
                                }}
                                style={{
                                    float: "right",
                                    marginLeft: "5%",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                    marginRight: "10px",
                                    backgroundColor: "#0188cc",
                                    color: "white",
                                }}
                            >
                                Close
                            </Button>
                        </InfoPaper>
                    </InfoModal>
                    {/* ------------------------------Copy Modal--------------------------- */}
                    <Modal isOpen={this.state.titleChangeModal}>
                        <ModalHeader style={{ color: "red" }}>
                            Change Title{" "}
                        </ModalHeader>
                        <ModalBody>
                            <Label for="name">
                                Enter New Template Name&nbsp;:&nbsp;&nbsp;
                            </Label>
                            <TextField
                                multiline={false}
                                style={{
                                    marginBottom: "11px",
                                    width: "100%",
                                }}
                                value={this.state.copyTitleName}
                                placeholder="Section Name"
                                onChange={(event) => {
                                    if (
                                        templateTitles.includes(
                                            event.target.value
                                        ) === true
                                    ) {
                                        this.setState({
                                            warningModal: true,
                                            warningMessage:
                                                "Template name already exists!!",
                                        });
                                    }
                                    let newName = event.target.value;
                                    this.setState({
                                        copyTitleName: newName,
                                    });
                                }}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                disabled={
                                    this.state.copyTitleName === ""
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    let newGroup = this.state.report_details;
                                    newGroup.report_title = this.state.copyTitleName;
                                    this.setState({
                                        report_details: newGroup,
                                    });
                                    this.props.templateCopy(
                                        this.state.copyTitleName,
                                        copyTemp,
                                        "report_templates"
                                    );
                                    this.props.removeTemplate(
                                        this.state.prevTitleName
                                    );
                                    this.props.getGroups(
                                        this.state.copyTitleName
                                    );
                                    this.setState({
                                        titleChangeModal: false,
                                        isTitleEntered: true,
                                        copyTitleName: "",
                                        prevTitleName: "",
                                    });
                                }}
                                style={{
                                    width: "100%",
                                    backgroundColor: "#0288CC",
                                    marginLeft: "5px",
                                    marginBottom: "24px",
                                    color: "white",
                                }}
                            >
                                Edit
                            </Button>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        titleChangeModal: false,
                                        isTitleEntered: true,
                                        copyTitleName: "",
                                        prevTitleName: "",
                                    });
                                }}
                                style={{
                                    width: "100%",
                                    backgroundColor: "#a9a5a5",
                                    marginLeft: "5px",
                                    marginBottom: "24px",
                                }}
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                    </Modal>
                </StyledContent>
            </StyledCard>
        );
    }
}
export default connect(
    (store) => {
        return {
            matrix: selectResponseMatrix(store),
            groups: selectGroup(store),
            items: selectItem(store),
            templates: selectTemplate(store),
            requesting: getRequesting(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            templateTitles: selectTemplateName(store),
            copyTemp: getSelectedTemplate(store),
        };
    },
    {
        getResponseMatrix,
        setResponseMatrixStatus,
        updateMatrix,
        setReportDetails,
        setSection2,
        setSection1,
        addGroup,
        getGroups,
        addItem,
        getItems,
        editGroup,
        removeGroup,
        editItem,
        removeItem,
        getTemplates,
        removeTemplate,
        archieveTemplate,
        getCopyTemplate,
        templateCopy,
    }
)(withStyles(styles)(Hsqe));
